module.exports = __webpack_public_path__ + "static/media/bts_lalela_170710_018_small.e76dc0ee.jpg";